import React, { useState, useEffect } from 'react';
import { Play, Info } from 'lucide-react';
import { Button } from './ui/button';
import { IMAGE_BASE_URL, getTrending, getMovieVideos, getTVVideos } from '../services/tmdb';

const Hero = ({ onPlayTrailer }) => {
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    loadHeroMovie();
  }, []);

  const loadHeroMovie = async () => {
    try {
      const trending = await getTrending();
      const randomMovie = trending[Math.floor(Math.random() * trending.length)];
      setMovie(randomMovie);
    } catch (error) {
      console.error('Error loading hero movie:', error);
    }
  };

  const handlePlayClick = async () => {
    if (!movie) return;
    try {
      const videos = movie.media_type === 'tv' 
        ? await getTVVideos(movie.id)
        : await getMovieVideos(movie.id);
      
      const trailer = videos.find(
        (video) => video.type === 'Trailer' && video.site === 'YouTube'
      );
      
      if (trailer && onPlayTrailer) {
        onPlayTrailer(trailer.key, movie.title || movie.name);
      }
    } catch (error) {
      console.error('Error loading trailer:', error);
    }
  };

  if (!movie) return null;

  const truncate = (str, n) => {
    return str?.length > n ? str.substr(0, n - 1) + '...' : str;
  };

  return (
    <div className="relative h-[85vh] w-full">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={`${IMAGE_BASE_URL}${movie.backdrop_path}`}
          alt={movie.title || movie.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/50 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center px-4 md:px-12">
        <div className="max-w-2xl space-y-6">
          <h1 className="text-5xl md:text-7xl font-bold text-white drop-shadow-2xl">
            {movie.title || movie.name}
          </h1>
          <p className="text-white text-lg md:text-xl drop-shadow-lg leading-relaxed">
            {truncate(movie.overview, 180)}
          </p>
          <div className="flex space-x-4">
            <Button
              onClick={handlePlayClick}
              className="bg-white text-black hover:bg-white/80 px-8 py-6 text-lg font-semibold rounded transition-all flex items-center space-x-2"
            >
              <Play size={24} fill="black" />
              <span>Play</span>
            </Button>
            <Button
              className="bg-gray-500/70 text-white hover:bg-gray-500/50 px-8 py-6 text-lg font-semibold rounded transition-all flex items-center space-x-2"
            >
              <Info size={24} />
              <span>More Info</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
